import React, { useState } from "react";
import { format, parse } from "date-fns";
import { es } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";
import { CalendarDays, X } from "lucide-react";

const toDate = (v) => (v ? parse(v, "yyyy-MM-dd", new Date()) : undefined);

export const DatePicker = ({ value, onChange, placeholder = "dd/mm/aaaa", testId }) => {
  const [open, setOpen] = useState(false);
  const d = toDate(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId}
          className="h-10 w-40 px-3 rounded-lg bg-secondary border border-border text-sm flex items-center gap-2 hover:border-primary transition-colors">
          <CalendarDays className="w-4 h-4 text-muted-foreground" />
          <span className={`flex-1 text-left font-data ${d ? "" : "text-muted-foreground"}`}>{d ? format(d, "dd/MM/yyyy") : placeholder}</span>
          {d && <span role="button" tabIndex={0} data-testid={`${testId}-clear`} onClick={(e) => { e.stopPropagation(); onChange(""); }} className="text-muted-foreground hover:text-destructive"><X className="w-3.5 h-3.5" /></span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 z-[80]" align="end">
        <Calendar mode="single" locale={es} weekStartsOn={1} selected={d} defaultMonth={d}
          onSelect={(day) => { onChange(day ? format(day, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
